import { data } from './data';
import type { Lang, Locale } from './types';

export function isSupportedLang(lang: string): lang is Lang {
	return lang in data.langs;
}

export function langFromLocale(locale: Locale): Lang | undefined {
	const lang = locale.toLowerCase().split('-')[0];
	return isSupportedLang(lang) ? lang : undefined;
}
